
































import { Vue, Component, Prop } from 'vue-property-decorator'
import PStorage from '@/util/PStorage'
import { Revision } from '@/store/revision/types'

@Component({ name: 'revision-title' })
export default class RevisionTitle extends Vue {
    /**
     * Revision to display information about
     */
    @Prop({ type: Object, required: true })
    revision!: Revision

    /**
     * Whether the peer is actually the current user
     */
    get you(): boolean {
        return this.revision.user.name === PStorage.get('username')
    }
}
